import { Link } from "react-router-dom";
import { ArrowUpRight, FileCheck2 } from "lucide-react";
import { tint } from "@/lib/mall";

/** The jobs we actually sell — each card says what a good file looks like for it. */
export function JobCards({ jobs, theme, picked = [], onPick }) {
    return (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="artwork-jobs">
            {jobs.map((j) => {
                const on = picked.includes(j.name);
                return (
                    <div key={j.key} data-testid={`artwork-job-${j.key}`}
                        className="group flex flex-col rounded-2xl border p-5 transition-transform duration-300 hover:-translate-y-1"
                        style={{ borderColor: on ? theme.primary : "rgba(0,0,0,0.10)", background: on ? tint(theme.primary, 0.07) : "#FFFFFF" }}>
                        <p className="font-display text-base font-black leading-tight">{j.name}</p>
                        <p className="mt-2 flex-1 text-sm text-zinc-500">{j.good}</p>
                        <div className="mt-4 flex items-center justify-between gap-2">
                            <Link to={j.to} className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-500 transition-colors group-hover:text-zinc-900">
                                the room <ArrowUpRight size={11} />
                            </Link>
                            {onPick && (
                                <button type="button" onClick={() => onPick(j.name)} data-testid={`artwork-pick-${j.key}`}
                                    className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.16em] transition-colors"
                                    style={{ borderColor: on ? theme.primary : "rgba(0,0,0,0.18)", color: on ? (theme.ink || theme.primary) : "#52525b" }}>
                                    <FileCheck2 size={10} /> {on ? "picked" : "pick it"}
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
